export const GLOBAL_CONSTANTS = {
  DEFAULT_ERROR: 'Something went wrong. Please try again later.',
  ERROR_CODE: {
    LIMIT: 'ReachThreshold',
    EXPIRE_TOKEN: 'ExpiredAuthToken',
    INVALID_TOKEN: 'InvalidAuthToken'
  },
  PLANS: {
    'free': {
      id: 1,
      code: 'free'
    },
    'launch': {
      id: 2,
      code: 'launch'
    },
    'universe': {
      id: 3,
      code: 'universe'
    },
    'pay-as-you-go': {
      id: 4,
      code: 'pay-as-you-go'
    }
  },
  ADDRESS_TYPE: {
    PRIMARY: "primary",
    USER: "user",
    ORDER: "order"
  },
  DIALOG_TYPE: {
    NOTICE: "notice",
    CONFIRM: 'confirm',
    SUCCESS: "success",
    ERROR: "error"
  },
  UID: "uid",
  NOTIFICATION_ID: "nid",
  COOKIE: {
    USER_NAME: "dfn",
    USER_ID: "duid",
    TOKEN: "dt",
    REFRESH: "drt",
    UTM: "dutm",
    SHORT_LINK: "dsl",
    LANGUAGE: "dc_hl",
    PLATFORM: "dc_pf",
    SHIPPING_COUNTRY: "dc_si",
    BILLING_COUNTRY: "dc_bi",
    CURRENCY: "dc_cur",
    UID: "uid",
    GA: "_ga",
    FOEID: "_foeid",
    TF: "_tf",
    TFID: "_tfid",
    VERSION: "dv",
    FIREBASE_TOKEN: "dft",
    NOTIFICATION_ID: "dnid",
    NEQ: "dneq",
    TARIFF_AI: "dtai",
  },
  MOBILE_SHORT_LINK_PARAM: "sl",
  MOBILE_IS_PRODUCT_SHORT_LINK_PARAM: "isProduct",
  CHECKSUM: "cks",
  ORDER_CODE: "oc",
  WELCOME_IMAGE_KEY: "i",
  WELCOME_BUTTON_LINK: "u",
  SITE_STATE: {
    PUBLISHED: "published",
    WELCOME: "welcome",
    DRAFT: "draft",
  },
  NOTIFICATION_STATE: {
    CLICKED: "clicked",
    OPENED: "opened",
    CLOSED: "closed",
  },
  LOCAL_NOTIFICATION_KEY: "localNotifications",
  INPUT_TYPE: {
    PHONE: "phone",
    INPUT: "input",
    SELECT: "select",
    SELECT_MULTIPLE: "select_multiple",
  },
};

export const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "fbclid",
  "aff_si",
];

export const APP_USER_KEY = "USERS";
export const PER_PAGE_STORE_EMPTY_SEARCH = 6;